@import '~less/global-variables';
@import './variables';

// Match the legacy large input's explicit height. Bootstrap 5's large button
// otherwise ends up two pixels taller and breaks the shared bottom border.
.search-place .input-group-btn {
  display: flex;
  align-items: stretch;

  .btn {
    height: @input-height-large;
  }
}

// Search input at sidebar (bigger screens)
.search-sidebar-section {
  .search-place {
    input[type='text'],
    .btn {
      &,
      &:disabled,
      &:hover,
      &:active,
      &:focus {
        border-color: @brand-primary;
      }
    }
    // Since we don't want to hide disabled buttons from DOM,
    // because that would mess with HTML/CSS, we basically hide
    // button content here and make it as un-noticeable as possible.
    .input-group-btn {
      .btn:disabled {
        opacity: 1;
        color: transparent;
        cursor: default;
      }
    }
  }
}

// Search input over the map (small screens)
.search-map-place {
  position: absolute;
  z-index: @zindex-navbar;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin-bottom: 0;
  border: 0;
  box-shadow: @map-toolbar-shadow;

  .form-group {
    margin: 0;
  }
  .search-place {
    // Location field's input and button are even highr than `input-lg`
    .input-location {
      .btn,
      .form-control {
        min-height: (@input-height-large + 10px);
      }
    }

    .btn {
      // Search buttons are narrow:
      max-width: 40px;
      padding-left: 7px;
      padding-right: 7px;
    }

    // Location sugestion
    .dropdown-menu {
      width: 100%;
      margin-top: -1px;
      border-top: 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      box-shadow: none;
      border: 0;
      @media (min-width: @grid-float-breakpoint) {
        border: 1px solid #eee;
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
      }
    }
  }
}

.search-form-group {
  width: auto;
  margin-right: 0;
  .btn,
  input[type='text'],
  input[type='search'] {
    border-radius: 0;
    &,
    &:disabled,
    &:hover,
    &:active,
    &:focus {
      background: #fff;
      border-color: #eee;
      outline: none;
      box-shadow: none;
    }
  }
  input[type='text'],
  input[type='search'] {
    border-right: 0;
  }
  .btn {
    border-left: 0;
  }
}
